import React from "react";
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function ErrorMessage() {
    const { t } = useTranslation();
    const error = useSelector(state => state.Auth.error);
    const apiError = useSelector(state => state.API.error);
    const errorMap = {
        REGISTER_USER_ALREADY_EXISTS: (
            <span>
                {t('error-user-exists')} <Link to="/signin">{t('error-sign-in-link')}</Link>
            </span>
        ),
        RESET_PASSWORD_BAD_TOKEN: t('error-reset-bad-token'),
        LOGIN_BAD_CREDENTIALS: (
            <span>
                {t('error-login-bad-credentials')} {t('error-reset-password-link-prefix')}{' '}
                <Link to="/auth/forgot">{t('error-reset-password-link')}</Link>
            </span>
        ),
    }

    return (
        <>
            {
                error &&
                <div className="alert alert-danger" role="alert">
                    {errorMap[error] || error.toString()}
                </div>
            }
            {
                apiError &&
                <div className="alert alert-danger" role="alert">
                    {errorMap[apiError] || apiError.toString()}
                </div>
            }
        </>
    );
}

export default ErrorMessage;
